import './DropDown.css';
import React, { useRef } from 'react';
import { get } from '../../utils';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import { ReactComponent as IconChevronRight } from '../../resources/icons/chevronArrowRightCharedChannels.svg';
import { addQueryStringMultiple, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
export const createFacets = (facets, allTagLabel) => {
  let filteredOptions = [];
  let allLabelSum = 0;
  if (facets) {
    filteredOptions = Object.keys(facets).map(item => ({
      key: item,
      label: facets[item],
      name: item
    }));
    allLabelSum = filteredOptions.reduce((acc, current) => current.label + acc, 0);
  }
  filteredOptions.unshift({
    key: allTagLabel,
    label: allLabelSum,
    name: allTagLabel
  });
  return filteredOptions.length !== 0 ? filteredOptions : undefined;
};
const DropDown = _ref => {
  let {
    fields,
    hideLabel,
    hideAmount,
    showLabel,
    clearAllLabel,
    buttonYellow,
    openWithWrapper,
    keepOpenOnChange,
    widgetAnalytics,
    facets,
    nbHits,
    setFilter,
    facetsName,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    defaultFacets,
    hideDesktopShowButton,
    hideShowButton,
    setSubpanelLabel,
    onChangeCallback,
    onToggleCallback,
    clearAlllFilters,
    analyticss,
    setStartPage,
    getFilterValue,
    primaryColor,
    columnsClass = 'col-md-3',
    resetAllFiltersCallback,
    allTagLabel,
    rtl
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const [isOpen, setisOpen] = React.useState(true);
  const filterName = get(fields, 'name');
  const {
    analytics
  } = analyticss;
  const label = get(fields, 'title.jss.value');
  const showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  const [filteredOptions, setfilteredOptions] = React.useState([]);
  const [filteredLabel, setfilteredLabel] = React.useState('');
  const selectedPrimaryColor = primaryColor ? primaryColor : 'var(--main-color)';
  const variables = {
    "--listing-dropdown-primary-color": buttonYellow ? 'var(--events-widget-primary-color)' : selectedPrimaryColor
  };
  const checkboxes = /*#__PURE__*/React.createRef();
  let history = useHistory();
  const type = "radio";
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const rootRef = useRef();
  const setChecked = checkboxes => {
    let setfilteredLabelArray = [];
    const queries = queryParams[`${filterType}`];
    const checkboxesArray = checkboxes && checkboxes.querySelectorAll('.input-choice');
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      checkboxesArray[i].checked = false;
    }
    queries && queries.split(splitter).map(item => {
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        if (checkboxesArray[i].value === item.split('+').join(' ')) {
          checkboxesArray[i].checked = true;
          if (setfilteredLabelArray.length === 0) {
            setfilteredLabelArray.push(checkboxesArray[i].value);
          } else {
            setfilteredLabelArray.push(', ' + checkboxesArray[i].value);
          }
        }
      }
    });
    const selected = {};
    filteredOptions.forEach(_ref2 => {
      let {
        key,
        label,
        name
      } = _ref2;
      selected[key] = false;
    });
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
      }
    }
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    if (setfilteredLabelArray.length !== 0) {
      setfilteredLabel(setfilteredLabelArray);
    } else {
      setfilteredLabel('');
    }
  };
  React.useEffect(() => {
    if (firstFilter === true) {
      setfilteredOptions(createFacets(facets, allTagLabel));
    } else {}
    if (filterType !== firstQuery) {
      setfilteredOptions(createFacets(facets, allTagLabel));
    }
  }, [facets, defaultFacets, facets]);
  React.useEffect(() => {
    setChecked(checkboxes.current);
  }, [filteredOptions, facets]);
  const submitFilters = (e, facetsName) => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    createFacets(facets, allTagLabel);
    const selected = {};
    filteredOptions.forEach(_ref3 => {
      let {
        key,
        label,
        name
      } = _ref3;
      selected[key] = false;
    });
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    setFilter(true, undefined, selectedCheckboxes);
    setisOpen(false);
    if (setStartPage) {
      setStartPage(true);
    }
    addQueryStringMultiple(facetsName, selected, history);
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field filter__field-dropdown",
    ref: rootRef,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter-panel eloqua filter-panel--open`
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `filter-panel__box filter-panel__box--openedDrop`,
    onClick: () => {
      onToggleCallback && onToggleCallback();
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (openWithWrapper) {} else {
        setisOpen(!isOpen);
      }
    },
    onKeyPress: event => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter' || event.which === 32) {
        event.preventDefault();
        onToggleCallback && onToggleCallback();
        if (openWithWrapper) {} else {
          setisOpen(!isOpen);
        }
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filteredLabel ? filteredLabel : label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, clearAllLabel ? /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, showSelectAllOption ? /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "body-medium fp__inner-clear cursor-pointer",
    onClick: e => {
      const inputs = checkboxes.current.querySelectorAll('.input-choice');
      inputs.forEach(input => {
        input.checked = true;
      });
      wrapperToggle(true);
      submitFilters(e, facetsName);
    },
    onKeyPress: e => {
      if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
        e.preventDefault();
        const inputs = checkboxes.current.querySelectorAll('.input-choice');
        inputs.forEach(input => {
          input.checked = true;
        });
        wrapperToggle(true);
        submitFilters(e, facetsName);
      }
    }
  }, '') : /*#__PURE__*/React.createElement("span", null)) : null, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: "filteredOptionsWrapper"
  }, filteredOptions.map((item, index) => {
    const {
      key,
      label,
      name
    } = item;
    const idKey = `${facetsName}_${key.replace(/\s/g, '_')}`;
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: idKey,
      key: index
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      className: `input-choice ${type === 'radio' ? 'fp__radio' : 'fp__checkbox'}`,
      type: type,
      name: `dropdown=${indexDropDown}`,
      value: key,
      onKeyPress: e => {
        if (e.key === 'Enter' || e.key === 'NumpadEnter') {
          e.preventDefault();
          e.target.checked = !e.target.checked;
          onChangeCallback && onChangeCallback();
          !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${name ? name : key}`);
          submitFilters(e, facetsName);
          wrapperToggle(true);
        }
      },
      onChange: e => {
        onChangeCallback && onChangeCallback();
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${name ? name : key}`);
        submitFilters(e, facetsName);
        setisOpen(true);
      },
      id: idKey
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, key, " ", hideAmount ? null : `(${label})`));
  }))), !hideDesktopShowButton || !hideShowButton ? /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: e => {
      wrapperToggle(true);
      submitFilters(e, facetsName);
    }
  }, /*#__PURE__*/React.createElement("span", null, showLabel), /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "dropdownIcon"
  }))) : null))));
};
const StyledWrapper = _ref4 => {
  let {
    children,
    columnsClass,
    rtl
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ""} ${columnsClass}`
  }, children);
};
export default DropDown;
const commonStyles = "c1d5e91q";
const rtlStyles = "rdi7ftm";